import css from 'styled-jsx/css'

export default css`
  .container {
    text-align: center;
    width: 100%;
  }

  .confirm-email-image {
    width: 294px;
    height: 294px;
  }

  .buttons-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`

export const button = css.global`
  .buttons-container .button {
    width: 160px;
    margin: 1rem;
  }
`